import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { format } from 'date-fns'

import { FlexColumn, FlexRow, SpaceBetweenRowContainer } from '../styles/Containers'
import { BoldFormTitle, MedBodyText, BoldMedBodyText } from '../styles/Text'

const LastModifiedRow = styled(FlexRow)`
  flex-wrap: wrap;
`

function formatDateParts(date) {
  if (!date) return { datePart: '—', timePart: '' }
  return {
    datePart: format(date, 'MMM-dd-yyyy'),
    timePart: format(date, 'hh:mm a')
  }
}

function getUserName(user) {
  if (!user) return ''
  return `${user.firstName} ${user.lastName}`
}

const labelMap = {
  SENT_INTERNAL: 'Sent at',
  SENT_EXTERNAL: 'Created',
  TEMPLATE: 'Last modified',
  DRAFT_FEE: 'Fee last modified',
  DRAFT_LETTER: 'Letter last modified',
  DRAFT_COMMUNICATION: 'Last modified'
}

function AttachmentReadOnlyHeading({ state, attachment }) {
  const { name, updatedAt, sentAt, sentBy, modifiedBy } = attachment

  const isSent = ['SENT_INTERNAL', 'SENT_EXTERNAL'].includes(state)
  const showUser = ['DRAFT_FEE', 'DRAFT_LETTER', 'DRAFT_COMMUNICATION', 'SENT_INTERNAL'].includes(state)

  const detailDate = isSent ? sentAt : updatedAt
  const detailLabel = labelMap[state]
  const heading = ['DRAFT_LETTER', 'DRAFT_COMMUNICATION'].includes(state) ? `Draft - ${name}` : name

  const dateParts = formatDateParts(detailDate)
  const userName = isSent ? getUserName(sentBy) : getUserName(modifiedBy)

  const detailLine = (
    <LastModifiedRow gap="5px">
      <MedBodyText>{detailLabel}:</MedBodyText>
      <BoldMedBodyText>
        {dateParts.datePart} {dateParts.timePart}
      </BoldMedBodyText>
      {showUser && userName && (
        <>
          <MedBodyText>by</MedBodyText>
          <BoldMedBodyText>{userName}</BoldMedBodyText>
        </>
      )}
    </LastModifiedRow>
  )

  return (
    <>
      {['TEMPLATE', 'SENT_EXTERNAL'].includes(state) ? (
        <SpaceBetweenRowContainer gap="10px">
          <BoldFormTitle>{heading}</BoldFormTitle>
          {detailLine}
        </SpaceBetweenRowContainer>
      ) : (
        <FlexColumn gap="0">
          <BoldFormTitle>{heading}</BoldFormTitle>
          {detailLine}
        </FlexColumn>
      )}
    </>
  )
}

const userSummaryPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired
})

AttachmentReadOnlyHeading.propTypes = {
  state: PropTypes.oneOf(['SENT_INTERNAL', 'SENT_EXTERNAL', 'TEMPLATE', 'DRAFT_FEE', 'DRAFT_LETTER', 'DRAFT_COMMUNICATION']).isRequired,
  attachment: PropTypes.shape({
    name: PropTypes.string.isRequired,
    updatedAt: PropTypes.instanceOf(Date),
    sentAt: PropTypes.instanceOf(Date),
    sentBy: userSummaryPropType,
    modifiedBy: userSummaryPropType
  }).isRequired
}

export default AttachmentReadOnlyHeading
